import { combineReducers } from 'redux'

import chat from './chat'
import user from './user'
import meet from './meet'
export default combineReducers({
  chat,
  user,
  meet
})